<template>
  <div>
    <div>
      <h1>Códigos de/para</h1>
      <div v-if="itemsCodigo.length == 0">
        <base-alert type="primary">{{ $t("proceda.nenhumDePara") }}</base-alert>
      </div>
      <div v-if="itemsCodigo.length > 0">
        <b-table
          id="table-de-para"
          hover
          :items="itemsCodigo"
          :fields="fieldsCodigo"
          selectable
          :select-mode="selectModeCodigo"
          @row-selected="onRowSelectedCodigo"
        >
          <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
          </template>-->
          <template v-slot:cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <template v-slot:cell(codigo)="row">
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="row.item.codigo"
              v-mask="'999999999'"
              v-on:change="onDataChange(row.item)"
            />
          </template>
          <template v-slot:cell(descricao)="row">
            <b-form-input
              type="text"
              placeholder="Descrição"
              v-model="row.item.descricao"
              v-on:change="onDataChange(row.item)"
            />
          </template>
        </b-table>
      </div>
      <b-button v-b-modal.modal-prevent-closing>Novo código</b-button>
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Novo código"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            :state="formModal.nameState"
            label="Código"
            label-for="input-codigo"
            invalid-feedback="Código é obrigatório"
          >
            <b-form-input
              type="text"
              id="input-codigo"
              placeholder="Código"
              v-model="formModal.codigo"
              :state="formModal.nameState"
              required
              v-mask="'999999999'"
            />
          </b-form-group>
          <b-form-group
            label="Descrição"
            label-for="input-descricao"
          >
            <b-form-input
              type="text"
              id="input-descricao"
              placeholder="Descrição"
              v-model="formModal.descricao"
            />
          </b-form-group>
        </form>
      </b-modal>
    </div>

    <div v-if="!selectedOcorrenciaCodigo.length">
      <base-alert type="primary">{{ $t("proceda.selecioneUmRegistro") }}</base-alert>
    </div>
    <div v-if="selectedOcorrenciaCodigo.length">
      <h1>Tabela PROCEDA</h1>

      <b-row>
        <b-col sm="6" md="6" lg="6">
          <!-- <h1>Tabela de ocorrências de/para</h1>
          <br />-->
          <h2>Códigos disponíveis</h2>

          <b-row>
            <b-table
              ref="selectableTable"
              id="table-tabela-proceda"
              hover
              :items="itemsTabelaProceda"
              :fields="fieldsTabelaProceda"
              :per-page="perPage"
              :current-page="currentPage"
              selectable
              :select-mode="selectModeTabelaProceda"
              @row-selected="onRowSelectedProceda"
            >
              <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
              <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
              </template>-->
            </b-table>
          </b-row>

          <b-row>
            <b-col sm="12" md="12" lg="12">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-number
                last-number
                aria-controls="table-tabela-proceda"
              ></b-pagination>
            </b-col>
            <b-col sm="12" md="12" lg="12">
              <label
                for="perPageSelect"
              >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{rows}}</label>
            </b-col>
            <b-col sm="12" md="12" lg="12">
              <b-row>
                <b-col sm="3" md="3" lg="3">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col style="padding-left: 0px;">
                  <label for="perPageSelect">registros exibidos por página</label>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- <p>
      Selected Rows:
      <br />
      {{ selectedTabelaProceda }}
          </p>-->
        </b-col>

        <b-col sm="1" md="1" lg="1"></b-col>

        <b-col sm="5" md="5" lg="5">
          <div>
            <!-- <h1>Tabela de ocorrências de/para</h1>
            <br />-->
            <h2>Adicionados</h2>

            <b-row>
              <b-table
                id="table-tabela-proceda-add"
                hover
                :items="itemsTabelaProcedaAdd"
                :fields="fieldsTabelaProcedaAdd"
              ></b-table>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { BaseAlert } from "src/components";

export default {
  name: "List",
  components: {
    BaseAlert,
  },
  data: function () {
    return {
      fieldsCodigo: [
        {
          label: "Selecionado",
          key: "selected",
        },
        {
          label: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          label: "Descrição",
          key: "descricao",
          sortable: true,
        },
      ],
      fieldsTabelaProceda: [
        {
          label: "Selecionado",
          key: "selected",
        },
        {
          label: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          label: "Descrição",
          key: "descricao",
          sortable: true,
        },
      ],
      fieldsTabelaProcedaAdd: [
        {
          label: "Código",
          key: "tabelaProcedaCodigo",
          sortable: true,
        },
        {
          label: "Descrição",
          key: "tabelaProcedaDescricao",
          sortable: true,
        },
      ],
      formModal: {
        codigo: 0,
        descricao: '',
        nameState: null,
      },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        data: {
          codigo: null,
          descricao: '',
        },
      },
      itemsCodigo: [],
      itemsTabelaProceda: [],
      itemsTabelaProcedaAdd: [],
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100, 150],
      currentPage: 1,
      selectModeCodigo: "single",
      selectModeTabelaProceda: "single",
      selectedOcorrenciaCodigo: [],
      selectedTabelaProceda: [],
    };
  },
  computed: {
    rows() {
      return this.itemsTabelaProceda.length;
    },
    paginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.perPage;
      if (to > this.rows) return this.rows;
      return to;
    },
  },
  created: function () {
    this.loadDataCodigo();
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async loadDataCodigo() {
      this.$api
        .get("/ocorrenciaCodigo/empresa/")
        .then((response) => {
          this.itemsCodigo = response.data;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
        });
    },
    async loadDataOcorrenciaDePara() {
      if (this.selectedOcorrenciaCodigo.length > 0) {
        const ocorrencia = this.selectedOcorrenciaCodigo[0];
        this.$api
          .get("/ocorrenciaDeParaVM/empresa/codigo/" + ocorrencia.codigo)
          .then((response) => {
            this.itemsTabelaProcedaAdd = response.data;
            this.loadDataTabelaProceda();
          })
          .catch((error) => {
            this.itemsTabelaProcedaAdd = [];
            this.loadDataTabelaProceda();

            console.log(error);
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            }
            console.log(error.response.data.errors);
          });
      }
    },
    async loadDataTabelaProceda() {
      this.$api
        .get("/tabelaOcorrenciaProceda")
        .then((response) => {
          this.itemsTabelaProceda = response.data;

          for (var i = this.itemsTabelaProceda.length - 1; i >= 0; i--) {
            for (var ocorrenciaAdd of this.itemsTabelaProcedaAdd) {
              if (
                this.itemsTabelaProceda[i].id ==
                ocorrenciaAdd.tabelaOcorrenciaProcedaId
              ) {
                this.itemsTabelaProceda.splice(i, 1);
              }
            }
          }
        })
        .catch((error) => {
          this.this.itemsTabelaProceda = [];

          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error.response.data.errors);
        });
    },
    onDataChange(item) {
      if (item.codigo) {
        item.codigo = parseInt(item.codigo);
        item.descricao = item.descricao;

        this.$apiNoAuthenticated
          .post("/ocorrenciaCodigo/edit/" + item.id.toString(), item)
          .then((response) => {
            console.log("Registro alterado");
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data.errors);
              }
            }
          });
      }
    },
    onRowSelectedCodigo(items) {
      this.selectedOcorrenciaCodigo = items;
      this.loadDataOcorrenciaDePara();
    },
    onRowSelectedProceda(items) {
      this.selectedTabelaProceda = items;

      if (
        this.selectedOcorrenciaCodigo.length > 0 &&
        this.selectedTabelaProceda.length > 0
      ) {
        const tabelaProceda = this.selectedTabelaProceda[0];
        const ocorrenciaCodigo = this.selectedOcorrenciaCodigo[0];

        const formModalData = {
          tabelaOcorrenciaProcedaId: tabelaProceda.id,
          codigo: ocorrenciaCodigo.codigo,
        };

        this.$api
          .post("/ocorrenciaDeParaVM/create", formModalData)
          .then((response) => {
            console.log("Registro criado");
            console.log(JSON.stringify(response.data));

            const item = response.data;
            this.itemsTabelaProcedaAdd.push(item);

            for (let i = this.itemsTabelaProceda.length - 1; i >= 0; i--) {
              if (
                this.itemsTabelaProceda[i].id == item.tabelaOcorrenciaProcedaId
              ) {
                this.itemsTabelaProceda.splice(i, 1);
              }
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data.errors);
              }
            }
          });
      }
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.formModal.nameState = valid;
      return valid;
    },
    resetModal() {
      this.formModal.codigo = 0;
      this.formModal.nameState = null;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      const formModalData = {
        codigo: parseInt(this.formModal.codigo),
        descricao: this.formModal.descricao,
      };

      this.$api
        .post("/ocorrenciaCodigo/create", formModalData)
        .then((response) => {
          console.log("Registro criado");
          this.itemsCodigo.push(response.data);

          this.$nextTick(() => {
            this.$bvModal.hide("modal-prevent-closing");
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 400) {
            if (error.response.data) {
              console.log(error.response.data.errors);
            }
          }
          this.$nextTick(() => {
            this.$bvModal.hide("modal-prevent-closing");
          });
        });
    },
  },
};
</script>

